import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetCustomers = () =>
  useMutation({
    mutationFn: () => client(`/lookups/customers`),
  });

export const useGetCustomerInfo = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/sites/hub/user/customer/info/${data}`),
  });

export const useGetCustomersListPaginated = () =>
  useMutation({
    mutationFn: (data) => client(`resources/customers`, { data }),
  });

export const useGetCustomerDetails = () =>
  useMutation({
    mutationFn: (id) => client(`resources/customers/${id}`),
  });

export const useDeleteCustomer = () =>
  useMutation({
    mutationFn: (id) =>
      client(`resources/customers/${id}`, {
        method: "delete",
        successMessage: "Customer has been deleted successfully",
      }),
  });

export const useAddCustomer = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/customers/add`, {
        data,
        message: "Customer has been added successfully",
      }),
  });
export const useEditCustomer = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/customers/edit`, {
        data,
        successMessage: "Customer has been updated successfully",
      }),
  });
